import React, { useEffect, useState } from 'react';
import Styles from './Achivements.module.scss';

// Module imports.
import { Tooltip as ReactTooltip } from "react-tooltip";

// Components import.
import { Card, Table, useAPI, Button } from 'components/lib';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';

export function Achievements(props) {

    const { data, loading } = useAPI('/api/allcerts');

    const [certs, setCerts] = useState([]);
    useEffect(() => {
        if (data?.length) {
            setCerts(data);
        }
    }, [data]);


    //azure blobstorage credentials
    // const accountName = process.env.REACT_APP_AZURE_ACCOUNT_NAME;
    // const sasToken = process.env.REACT_APP_AZURE_BLOB_STORAGE_SAS_TOKEN;
    // const containerName = process.env.REACT_APP_AZURE_BLOB_CONTAINER_NAME;

    // const handleDownload = (userCertId) => {
    //     const imageUrl = `https://${accountName}.blob.core.windows.net/${containerName}/${userCertId}.png?${sasToken}`
    //     const link = document.createElement('a');
    //     link.href = imageUrl;
    //     document.body.appendChild(link);
    //     link.click();
    // };
    let serialNumber = 1;

    const DownloadAndView = (userCertId) => {
        return (
            <div style={{
                display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', padding: 4, gap: 27,
                width: 'fit-content', justifyContent: 'flex-start', alignItems: 'center'
            }}>
                {/* <div data-tooltip-id="download-tooltip" >
                    <Button icon='download' action={() => { handleDownload(userCertId) }} />
                </div> */}
                <div data-tooltip-id="view-tooltip">
                    <Button icon='eye' url={`certificate/${userCertId}`} />
                </div>
                <ReactTooltip
                    id="view-tooltip"
                    place="bottom"
                    content={props.t('LearningPath.Achievements.tooltip.view')}
                />
                <ReactTooltip
                    id="download-tooltip"
                    place="bottom"
                    content={props.t('LearningPath.Achievements.tooltip.download')}
                />
            </div>
        );
    }

    return (
        <>
            <Card className={Styles.cardContainer}>
                {loading ? (
                    <div>
                        <LoadingBackdrop isOpen={true} />
                    </div>
                ) : certs.length > 0 ? (
                    <>

                        <Table
                            search
                            loading={loading}
                            data={certs?.map(x => {
                                return {
                                    No: serialNumber++,
                                    date: x.cert_unlocked,
                                    Name: x.name,
                                    cert_id: x.user_cert_id,
                                    Options: DownloadAndView(x.user_cert_id)
                                }
                            })
                            }
                            translation='LearningPath.Achievements.table'
                        />
                    </>) : (
                    <div style={{ paddingLeft: '22px' }}>{props.t('LearningPath.Achievements.message')}</div>)
                }
            </Card>
        </>
    );
}
